import Page from 'src/components/Page';
import {
    Card, CardContent, Container,
    Link, Stack, TextField, Typography,
    useMediaQuery, Switch
}
    from '@mui/material';
import { LoadingButton } from '@mui/lab';
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Link as RouterLink, useNavigate, useParams } from 'react-router-dom';
import { useFormik, Form, FormikProvider, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { apiInstance } from 'src/utils/apiAuth';
import { showErrorToast, showToast } from 'src/utils/Toast/SnackbarProvider';


export default function AddCompanyType() {
    const id = useParams();
    const hrToken = localStorage.getItem("authToken");
    const navigate = useNavigate();

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [companyTypeData, setCompanyTypeData] = useState([]);
    const getCompanyTypeData = () => {
        apiInstance({
            method: "get",
            url: "company-type/" + id.id,
            headers: {
                Authorization: "token " + hrToken,
            }
        })
            .then(function (response) {
                setCompanyTypeData(response?.data?.data);
            })
            .catch(function (error) {
                showErrorToast(error);
            });
    }

    useEffect(() => {
        if (id?.id) getCompanyTypeData();
    }, [id, id?.id])

    const callAddCompanyTypeAPI = (formValues) => {
        apiInstance({
            method: "post",
            url: "company-type/",
            headers: {
                Authorization: "token " + hrToken,
            },
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message)
                navigate("/company-type", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false)
            });
    }

    const callEditCompanyTypeAPI = (formValues) => {
        apiInstance({
            method: "put",
            url: "company-type/" + id.id + "/",
            data: formValues,
        })
            .then(function (response) {
                showToast(response.data.message);
                navigate("/company-type", { replace: true });
            })
            .catch(function (error) {
                showErrorToast(error);
                setSubmitting(false);
            });
    }

    useEffect(() => {
        if (id && companyTypeData) {
            formik.setValues({
                label: companyTypeData?.label || '',
                order: companyTypeData?.order || '',
                is_active: companyTypeData?.is_active || false,
            });
        }
    }, [id, companyTypeData]);

    const Schema = Yup.object().shape({
        label: Yup.string()
            .required("Comany Type is required"),
        order: Yup.number()
            .required("Order required."),
        is_active: Yup.string()
            .required("Active status is required."),
    });

    const formik = useFormik({
        initialValues: {
            label: '',
            order: '',
            is_active: false,
        },
        validationSchema: Schema,
        onSubmit: (values) => {
            let formData = {
                "label": values.label,
                "name": (values.label).toUpperCase(),
                "order": values.order,
                "is_active": values.is_active,
            }
            if (id?.id) {
                callEditCompanyTypeAPI(formData)
            } else {
                callAddCompanyTypeAPI(formData)
            }
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps, setSubmitting, setFieldValue, handleChange } = formik;

    return (
        <Page title="Add Company Type">
            <Container maxWidth="xl">
                <Stack direction="row" sx={{ mb: 2, justifyContent: "space-between", alignItems: "center" }}>
                    <Link to="/company-type" color="green" underline="hover" component={RouterLink} fontSize="20px">
                        <ArrowCircleLeftIcon fontSize="large" />
                    </Link>
                    <Typography variant="h4" sx={{ my: matches ? 0 : 5 }} align="center" color="black">
                        {id?.id ? "Update Company Type" : "Add Company Type"}
                    </Typography>
                    <div></div>
                </Stack>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Card sx={{ mt: 2, marginInline: 'auto' }} variant="outlined" style={{ width: matches ? '70%' : '50%' }}>
                            <CardContent>
                                <Stack spacing={3}>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            label="Company Type"
                                            {...getFieldProps('label')}
                                            error={Boolean(touched.label && errors.label)}
                                            helperText={touched.label && errors.label}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                                        <TextField
                                            fullWidth
                                            type='number'
                                            label="Order"
                                            {...getFieldProps('order')}
                                            error={Boolean(touched.order && errors.order)}
                                            helperText={touched.order && errors.order}
                                        >
                                        </TextField>
                                    </Stack>
                                    <Stack>
                                        <div role="group" style={{ width: '40%' }}>
                                            <Stack
                                                direction={{ xs: "column", sm: "row" }}
                                                spacing={3}
                                                style={{ padding: "20px 0 0 12px" }}
                                            >
                                                <div id="switch-label" style={{ color: '#637381', marginTop: '5px' }}> Is Active? </div>
                                                <Switch
                                                    name="is_active"
                                                    checked={values.is_active}
                                                    onChange={(event, checked) => {
                                                        setFieldValue("is_active", checked);
                                                    }}
                                                />
                                            </Stack>
                                            <ErrorMessage name="is_active">
                                                {(msg) => <span style={{ color: "#FF4842", fontSize: "12px", marginLeft: 15 }}>{msg}</span>}
                                            </ErrorMessage>
                                        </div>
                                    </Stack>
                                </Stack>

                            </CardContent>
                        </Card>
                        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }} />
                        <LoadingButton
                            size="large"
                            type="submit"
                            variant="contained"
                            loading={isSubmitting}
                            style={{ display: "block", margin: "auto", width: 400 }}
                        >
                            Add Company Type
                        </LoadingButton>
                    </Form>
                </FormikProvider>
            </Container>
        </Page >
    )
}